import { animate } from '~/animations';
import { parseHTML, replaceElement } from '~/helpers';
import { HTMLCustomElement } from '~/html-custom-element';
import { SplitText } from 'gsap/splittext';

customElements.define(
  'product-listing',
  class ProductListing extends HTMLCustomElement {
    connectedCallback() {
      if (super.connectedCallback) super.connectedCallback();

      this.on('change', this.targets.sort, this.handleFormSubmit.bind(this));
      this.on('change', this.targets.filters, this.handleFormSubmit.bind(this));

      if (this.targets.item) {
        animate.fromTo(
          this.targets.item.all,
          {
            opacity: 0,
          },
          {
            opacity: 1,
            stagger: 0.25,
            scrollTrigger: this,
          }
        );
      }

      if (this.targets.banner) {
        this.targets.banner.all.forEach((banner) => {
          animate.fromTo(
            banner.querySelectorAll('.product-listing-banner__line'),
            {
              opacity: 0,
              y: '10%',
            },
            {
              opacity: 1,
              y: 0,
              delay: 0.5,
              stagger: 0.5,
              scrollTrigger: {
                trigger: banner,
                start: 'top bottom-=25%',
              },
            }
          );

          [
            SplitText.create(banner.querySelector('.product-listing-banner__details-heading'), {
              type: 'chars',
            }),
            SplitText.create(banner.querySelector('.product-listing-banner__details-body'), {
              type: 'chars',
            }),
          ].forEach((element, index) => {
            animate.from(
              element.chars,
              {
                visibility: 'hidden',
                stagger: 0.025,
                scrollTrigger: {
                  trigger: banner,
                  start: 'top bottom-=25%',
                },
              },
              index === 0 ? '<' : `details-${index}`
            );
          });
        });
      }
    }

    /**
     * Handles the sort or filter form submit event.
     * @param {SubmitEvent} event - The form submit event.
     */
    handleFormSubmit(event) {
      event.preventDefault();

      const sectionId = this.getAttribute('section-id');
      const data = [...new FormData(this.targets.filters), ...new FormData(this.targets.sort)];
      const params = this.filterSearchParams(new URLSearchParams(data));
      const query = new URLSearchParams([...params.entries(), ['section_id', sectionId]]).toString();
      const { origin, pathname } = window.location;

      fetch(`${origin}${pathname}?${query}`)
        .then((response) => response.text())
        .then((response) => {
          replaceElement(this, parseHTML(response, this.tagName.toLowerCase()));

          /**
           * Update the query parameters.
           */
          window.history.pushState({}, '', `${origin}${pathname}${params.size === 0 ? '' : `?${params.toString()}`}`);
        });
    }

    /**
     * Filters out empty values, or the default sort by option.
     * @param {URLSearchParams} params - The search params.
     * @returns {URLSearchParams}
     */
    filterSearchParams(params) {
      return new URLSearchParams([
        ...params
          .entries()
          .filter(
            ([key, value]) => !(value === '' || (key === 'sort_by' && value === this.getAttribute('default-sort-by')))
          ),
      ]);
    }
  }
);
